import { NumericTextBox } from "@progress/kendo-react-inputs";
import { MaskedTextBox } from "@progress/kendo-react-inputs"
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { useState } from "react";
import { DropDownButton } from "@progress/kendo-react-buttons";

interface NumericFilterCellProps {
    props: GridFilterCellProps,
    format: string
}

export const NoCommaNumericFilterCell = (props: GridFilterCellProps) => {
    return <NumericFilterCell props={props} format="#" />;
}
export const FiveDecimalPlaceNumericFilterCell = (props: GridFilterCellProps) => {
    return <NumericFilterCell props={props} format="n5" />;
}

const NumericFilterCell = (_props: NumericFilterCellProps) => {
    const props = _props.props;
    const onValueChange = (event: any) => {
        setValue(event.value);
        if (event.value === null) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else {
            props.onChange({
                value: event.value,
                operator: operator.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };
    const onOperatorChange = (event: any) => {
        setOperator(event.item);
        if (value === null) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else {
            props.onChange({
                value: value,
                operator: event.item.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };
    const [value, setValue] = useState(null as null | number);
    const [operator, setOperator] = useState({ text: 'Equal', operator: 'eq' });
    return (
        <div className="k-filtercell">
            <NumericTextBox
                value={value}
                format={_props.format}
                onChange={onValueChange}
                spinners={false}
            />&nbsp;
            <div className="k-filtercell-operator">
                <DropDownButton textField={"text"} onItemClick={onOperatorChange} iconClass='k-i-filter k-icon' items={[
                        { text: 'Equal', operator: 'eq' },
                        { text: 'Not Equal', operator: 'neq' },
                        { text: 'Greater Than', operator: 'gte' },
                        { text: 'Greater Than or Equal', operator: 'gt' },
                        { text: 'Less Than', operator: 'lte' },
                        { text: 'Less Than or Equal', operator: 'lt' },
                    ]}
                ></DropDownButton>
            </div>
        </div>
    );
};

export const ZeroPaddedNumericFilterCell = (props: GridFilterCellProps) => {
    const onValueChange = (event: any) => {
        setValue(event.value);
        if (event.value === undefined || event.value === "_____") {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else if (event.value.toString().indexOf("_") >= 0) {
            return;
        } else {
            props.onChange({
                value: event.value,
                operator: operator.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };
    const onOperatorChange = (event: any) => {
        setOperator(event.item);
        if (value === undefined) {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event,
            });
        } else {
            props.onChange({
                value: value,
                operator: event.item.operator,
                syntheticEvent: event.syntheticEvent,
            });
        }
    };

    const [value, setValue] = useState(undefined as string | undefined);
    const [operator, setOperator] = useState({ text: 'Equal', operator: 'eq' });
    return (
        <div className="k-filtercell">
            <MaskedTextBox
                defaultValue=""
                valid={true}
                value={value}
                mask="00000"
                onChange={onValueChange}
            />&nbsp;
            <div className="k-filtercell-operator">
                <DropDownButton textField={"text"} onItemClick={onOperatorChange} iconClass='k-i-filter k-icon' items={[
                    { text: 'Equal', operator: 'eq' },
                    { text: 'Not Equal', operator: 'neq' },
                    { text: 'Greater Than', operator: 'gte' },
                    { text: 'Greater Than or Equal', operator: 'gt' },
                    { text: 'Less Than', operator: 'lte' },
                    { text: 'Less Than or Equal', operator: 'lt' },
                ]}
                ></DropDownButton>
            </div>
        </div>
    );
};